import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,TabbedForm,FormTab,Create
 }
from 'admin-on-rest/lib/mui';

export const AgentList = (props) => (
    <List title=" רשימת סוכנים" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
             <TextField label="סוכן" source="name" />

   <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const AgentTitle = ({ record }) => {
    return <span>Agent {record ? `"${record.name}"` : ''}</span>;
};


export const AgentShow = (props) => (

<Show title={<AgentTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
        <TextField label="סוכן" source="name" />


         </SimpleShowLayout>
    </Show>
);


export const AgentEdit = (props) => (
    <Edit {...props}>

        <SimpleForm>
 <DisabledInput source="id" />
<TextInput  source="name" />

        </SimpleForm>
  </Edit>
);

export const AgentCreate = (props) => (
    <Create title="הוספת סוכן חדש" {...props}>
      <SimpleForm >

              <DisabledInput label="Id" source="id" />
                <TextInput source="name" label="סוכן"/>
      </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/components/Agents/agents.js